import React from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import CheckIcon from '@material-ui/icons/Check';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import { makeStyles } from '@material-ui/core/styles';

import { getTaxPercent } from '../common';
import InvoiceCreateDialog from '../Invoices/InvoiceCreateDialog';


const useStyles = makeStyles(theme => ({
    feesForm: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1),
            '& .MuiInput-root': {
                marginRight: theme.spacing(3)
            }
        },
    },
    verticalDivider: {
        borderLeftColor: theme.palette.divider,
        borderLeftStyle: 'solid',
        borderLeftWidth: 1
    },
    invoiceButton: {
        marginTop: theme.spacing(1)
    },
    calculatedText: {
        color: theme.palette.primary.main
    }
}));

const FeeLabelDialog = (props) => {
    const {
        open,
        handleClose,
        title,
        updateState
    } = props;

    const [state, setState] = React.useState(title);

    const handleChange = event => {
        const value = event.target.value;
        setState(value);
    }

    const handleSetClick = () => {
        updateState(state, 'other_fee_label')
        handleClose();
    }

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Set fee label</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    value={state}
                    onChange={handleChange}
                    label="Fee label"
                    type="text"
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSetClick} color="primary">
                    Set
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const FeesTab = (props) => {
    const { couple } = props;

    const classes = useStyles();

    const parseNum = num => parseFloat(num || 0);

    const formatNumber = number => {
        return parseNum(number).toFixed(2);
    }

    const fees = {
        ceremony_fee: couple.fees ? couple.fees.ceremony_fee : couple.default_ceremony_fee,
        second_meeting_fee: couple.fees ? couple.fees.second_meeting_fee : 0,
        rehearsal_fee: couple.fees ? couple.fees.rehearsal_fee : 0,
        other_fee: couple.fees ? couple.fees.other_fee : 0,
        deposit: couple.fees ? couple.fees.deposit : 0,
        additional_payments: couple.fees ? couple.fees.additional_payments : 0,
        cash: couple.fees ? couple.fees.cash : 0
    };
    const taxPercent = getTaxPercent(couple);
    const taxPercentLabel = taxPercent ? ` (${taxPercent*100}%)` : '';

    fees.sub_total = parseNum(fees.ceremony_fee) + parseNum(fees.second_meeting_fee) + parseNum(fees.rehearsal_fee) + parseNum(fees.other_fee);
    fees.tax = taxPercent * fees.sub_total;
    fees.total = fees.sub_total + fees.tax;
    fees.balance = fees.total - (parseNum(fees.deposit) + parseNum(fees.additional_payments));

    const [state, setState] = React.useState({
        ceremony_fee: formatNumber(fees.ceremony_fee),
        second_meeting_fee: formatNumber(fees.second_meeting_fee),
        rehearsal_fee: formatNumber(fees.rehearsal_fee),
        other_fee: formatNumber(fees.other_fee),
        other_fee_label: couple.fees ? couple.fees.other_fee_label : 'Travel Fee',
        sub_total: formatNumber(fees.sub_total),
        tax: formatNumber(fees.tax),
        total: formatNumber(fees.total),
        deposit: formatNumber(fees.deposit),
        additional_payments: formatNumber(fees.additional_payments),
        cash: formatNumber(fees.cash),
        balance: formatNumber(fees.balance),
        location_meeting: couple.location_meeting,
        location_rehearsal: couple.location_rehearsal,
        wedding_type: couple.wedding_type,
    });

    const [savePending, setSavePending] = React.useState(false);
    const [saveComplete, setSaveComplete] = React.useState(false);

    /* State for FeesLabelDialog */
    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    /* State for InvoiceCreateDialog */
    const [invoiceDialogOpen, setInvoiceDialogOpen] = React.useState(false);
    const [invoiceFees, setInvoiceFees] = React.useState({});
    const openInvoiceCreateDialog = type => event => {
        if (type == 'standard') {
            let line_2_text;
            if (parseNum(state.second_meeting_fee)) {
                line_2_text = 'Second Meeting Fee';
            }
            if (parseNum(state.rehearsal_fee)) {
                line_2_text = line_2_text ? line_2_text + '. Rehearsal Fee': 'Rehearsal Fee';
            }
            setInvoiceFees({
                amount_1: parseNum(state.ceremony_fee),
                comments_1: 'Ceremony Fee',
                amount_2: parseNum(state.second_meeting_fee) + parseNum(state.rehearsal_fee),
                comments_2: line_2_text,
                amount_3: parseNum(state.other_fee) ? parseNum(state.other_fee) : '',
                comments_3: parseNum(state.other_fee) ? state.other_fee_label : '',
                sub_total: parseNum(state.sub_total),
                tax: parseNum(state.tax),
                total: parseNum(state.total)
            })
        } else if (type == 'late-fee') {
            setInvoiceFees({
                amount_1: 100,
                comments_1: 'Late Fee',
                amount_2: '',
                comments_2: '',
                amount_3: '',
                comments_3: '',
                sub_total: 100,
                tax: taxPercent * 100,
                total: 100 + (taxPercent * 100)
            })
        } else if (type == 'postponement') {
            setInvoiceFees({
                amount_1: 125,
                comments_1: 'Postponement Fee',
                amount_2: '',
                comments_2: '',
                amount_3: '',
                comments_3: '',
                sub_total: 125,
                tax: taxPercent * 125,
                total: 125 + (taxPercent * 125)
            })
        }
        setInvoiceDialogOpen(true);
    };
    const closeInvoiceCreateDialog = () => {
        setInvoiceDialogOpen(false);
    };

    const updateState = (value, name) => {
        const data = {
            ...state,
            [name]: value,
        };
        if (name == 'location_meeting' || name == 'location_rehearsal' || name == 'other_fee_label') {
            setState(data);
            return;
        }

        /* TODO: can we clean this up */

        const subTotal = formatNumber(
            parseNum(data.ceremony_fee)
            + parseNum(data.second_meeting_fee)
            + parseNum(data.rehearsal_fee)
            + parseNum(data.other_fee)
        );
        const tax = formatNumber(taxPercent * parseNum(subTotal));
        const total = formatNumber(parseNum(tax) + parseNum(subTotal));
        const balance = formatNumber(parseNum(total) - (parseNum(data.deposit) + parseNum(data.additional_payments)));
        setState({
            ...data,
            sub_total: subTotal,
            tax: tax,
            total: total,
            balance: balance
        });
    }

    const handleChange = name => event => {
        const value = event.target.value;
        updateState(value, name);
    }

    const handleSubmit = () => {
        const formData = {
            ...state,
            _token: window._token
        };
        new Promise((resolve, reject) => {
            let url = `/api/couples/${couple.id}/fees`;
            setSavePending(true);
            fetch(url, {
                method: 'PUT',
                body: JSON.stringify(formData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    /**
                     * Might need this
                    setCouple(result.wedding);
                    */
                    setSaveComplete(true);
                    setSavePending(false);
                    setTimeout(() => {
                        setSaveComplete(false);
                    }, 5000);
                    resolve();
                })
                .catch(reason => {
                    setSavePending(false);
                    alert('Please make sure all required fields have been entered.');
                })
        });
    };

    const handleInvoiceButtonClick = () => {
        openInvoiceCreateDialog();
    }

    return (
        <form className={classes.feesForm}>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="fees-ceremony-fee">Ceremony Fee</InputLabel>
                        <Input
                            id="fees-ceremony-fee"
                            value={state.ceremony_fee || ''}
                            onChange={handleChange('ceremony_fee')}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            type="number"
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="fees-second-meeting-fee">Second Meeting Fee</InputLabel>
                        <Input
                            id="fees-second-meeting-fee"
                            value={state.second_meeting_fee || ''}
                            onChange={handleChange('second_meeting_fee')}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            type="number"
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="fees-rehearsal-fee">Rehearsal Fee</InputLabel>
                        <Input
                            id="fees-rehearsal-fee"
                            value={state.rehearsal_fee || ''}
                            onChange={handleChange('rehearsal_fee')}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            type="number"
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="fees-travel-fee">
                            {state.other_fee_label}
                            <IconButton size='small' color="inherit" onClick={handleClickOpen}>
                                <Icon fontSize='small'>edit</Icon>
                            </IconButton>
                        </InputLabel>
                        <Input
                            id="fees-travel-fee"
                            value={state.other_fee || ''}
                            onChange={handleChange('other_fee')}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            type="number"
                        />
                    </FormControl>

                    <FormControl fullWidth style={ { marginTop: 30 }}>
                        <InputLabel htmlFor="fees-sub-total" className={classes.calculatedText}>Sub Total</InputLabel>
                        <Input
                            id="fees-sub-total"
                            value={state.sub_total || 0}
                            onChange={handleChange('sub_total')}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            type="number"
                            inputProps={ { readOnly: true } }
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="fees-tax" className={classes.calculatedText}>{`Tax${taxPercentLabel}`}</InputLabel>
                        <Input
                            id="fees-tax"
                            value={state.tax || 0}
                            onChange={handleChange('tax')}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            type="number"
                            inputProps={ { readOnly: true } }
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="fees-total" className={classes.calculatedText}>Total</InputLabel>
                        <Input
                            id="fees-total"
                            value={state.total || 0}
                            onChange={handleChange('total')}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            type="number"
                            inputProps={ { readOnly: true } }
                        />
                    </FormControl>

                    <FormControl fullWidth style={ { marginTop: 30 }}>
                        <InputLabel htmlFor="fees-deposit">Deposit</InputLabel>
                        <Input
                            id="fees-deposit"
                            value={state.deposit || ''}
                            onChange={handleChange('deposit')}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            type="number"
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="fees-additional-payments">Additional Payments</InputLabel>
                        <Input
                            id="fees-additional-payments"
                            value={state.additional_payments || ''}
                            onChange={handleChange('additional_payments')}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            type="number"
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="fees-balance" className={classes.calculatedText}>Balance</InputLabel>
                        <Input
                            id="fees-balance"
                            value={state.balance || 0}
                            onChange={handleChange('balance')}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            type="number"
                            inputProps={ { readOnly: true } }
                        />
                    </FormControl>

                    <FormControl fullWidth style={ { marginTop: 30 }}>
                        <InputLabel htmlFor="fees-cash">Cash</InputLabel>
                        <Input
                            id="fees-cash"
                            value={state.cash || ''}
                            onChange={handleChange('cash')}
                            startAdornment={<InputAdornment position="start">$</InputAdornment>}
                            type="number"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6} className={classes.verticalDivider}>
                    <TextField
                        select
                        fullWidth
                        label="Wedding Type"
                        value={state.wedding_type}
                        onChange={handleChange('wedding_type')}
                        style={{width: 190}}
                        SelectProps={{
                            autoWidth: true,
                            MenuProps: {
                                className: classes.selectMenu
                            }
                        }}
                    >
                        <MenuItem value={0}>Ceremony</MenuItem>
                        <MenuItem value={1}>Elopement</MenuItem>
                        <MenuItem value={2}>Officiant of the Day</MenuItem>
                    </TextField>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('location_meeting')}
                        label="Meeting Location"
                        value={state.location_meeting || ''}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('location_rehearsal')}
                        label="Rehearsal Location"
                        value={state.location_rehearsal || ''}
                    />
                </Grid>
            </Grid>
            <Box mt={4} mb={3}>
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <Grid item xs={8} sm={4}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth={true}
                            onClick={handleSubmit}
                            disabled={savePending ? true : false}
                            endIcon={savePending ? <CircularProgress size={20} /> : (saveComplete ? <CheckIcon /> : null)}
                        >
                            Save Changes
                        </Button>
                        <Box mt={2}>
                            {isAdmin &&
                                <React.Fragment>
                                    <Button variant="outlined" fullWidth={true} onClick={openInvoiceCreateDialog('standard')} className={classes.invoiceButton}>
                                        Create Standard Invoice
                                    </Button>
                                    <Button variant="outlined" fullWidth={true} onClick={openInvoiceCreateDialog('late-fee')} className={classes.invoiceButton}>
                                        Create Late Fee Invoice
                                    </Button>
                                    <Button variant="outlined" fullWidth={true} onClick={openInvoiceCreateDialog('postponement')} className={classes.invoiceButton}>
                                        Create Postponement Fee Invoice
                                    </Button>
                                </React.Fragment>
                            }
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <FeeLabelDialog open={open} handleClose={handleClose} title={state.other_fee_label} updateState={updateState} />
            <InvoiceCreateDialog open={invoiceDialogOpen} handleClose={closeInvoiceCreateDialog} fees={invoiceFees} couple={couple} scroll='paper' />
        </form>
    );
};

export default FeesTab;
